<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="chart-column"
			class="svg-inline--fa fa-chart-column"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M496 448h-416C53.53 448 32 426.5 32 400v-352C32 39.16 24.84 32 16 32S0 39.16 0 48v352C0 444.1 35.88 480 80 480h416c8.844 0 16-7.156 16-16S504.8 448 496 448zM159.1 368C168.8 368 176 360.8 176 352V256c0-8.844-7.156-16-16-16S143.1 247.2 143.1 256L144 352C144 360.8 151.1 368 159.1 368zM255.1 368C264.8 368 272 360.8 272 352V128c0-8.844-7.156-16-16-16S239.1 119.2 239.1 128L240 352C240 360.8 247.1 368 255.1 368zM351.1 368C360.8 368 368 360.8 368 352V192c0-8.844-7.156-16-16-16S335.1 183.2 335.1 192L336 352C336 360.8 343.1 368 351.1 368zM447.1 368C456.8 368 464 360.8 464 352V96c0-8.844-7.156-16-16-16S431.1 87.16 431.1 96L432 352C432 360.8 439.1 368 447.1 368z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M488 432H48V56C48 42.74 37.25 32 24 32S0 42.74 0 56V448c0 17.6 14.4 32 32 32h456c13.25 0 24-10.75 24-24C512 442.7 501.3 432 488 432zM168 352C181.3 352 192 341.3 192 328v-48C192 266.8 181.3 256 168 256S144 266.8 144 280v48C144 341.3 154.8 352 168 352zM264 352c13.25 0 24-10.75 24-24v-176C288 138.8 277.3 128 264 128S240 138.8 240 152v176C240 341.3 250.8 352 264 352zM360 352c13.25 0 24-10.75 24-24v-112C384 202.8 373.3 192 360 192S336 202.8 336 216v112C336 341.3 346.8 352 360 352zM456 352c13.25 0 24-10.75 24-24v-208C480 106.8 469.3 96 456 96S432 106.8 432 120v208C432 341.3 442.8 352 456 352z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ChartIcon',
	components: { Icon },
	props,
}
</script>
